// R3N13R - CSS for register provider
import { container, title } from "assets/jss/material-kit-react.js";

const landingPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container,
    alignContent:'center'
  },
  spacing: {
    paddingLeft: "0",
    marginTop: "15px",
    zIndex: "12",
    color: "#FFFFFF",
    alignContent:'center'
  },
  stepper: {
    marginTop: '10px'
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "5px",
    color: "#9c27b0",
    textDecoration: "none",
    fontSize: "x-large"
  },
  instructions: {
    color: "green",
    fontSize: "small",
    maxWidth: "500px",
    marginTop: "10px"
  },
  gridcontainer:{
    alignContent:'center'
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0"
  },
  category: {
    marginTop: "-10px",
    marginBottom: "-20px",
    color: "#FFFFFF",
    fontSize: 24,
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  main2: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised2: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  items:{
    margin:0,
    width:'100%'
  },
  menuItems:{
    width:'100%'
  },
  input: {
    height: 75,
    borderRadius: 4,
    position: 'relative',
    backgroundColor:  "#E8E8E8",
    fontSize: 14,
    padding: '10px 2px 10px 10px',
    color:"#000"
  },
  custominput: {
    height: 75,
    borderRadius: 4,
    position: 'relative',
    backgroundColor:  "#E8E8E8",
    fontSize: 14,
    padding: '10px 2px 10px 10px',
    color:"#000"
  },
  inputIconsColor: {
    color:"#000"
  },
  inputdimmed: {
    height: 75,
    borderRadius: 4,
    position: 'relative',
    backgroundColor:  "#E8E8E8",
    fontSize: 14,
    padding: '10px 26px 10px 10px',
    color:"#737373"
  },
  commonInputStyle:{
    borderRadius: 4,
    backgroundColor: "#E8E8E8",
  },
  productPic:{
    height: '36px',
    width: '36px',
    marginRight:'10px'
  }
};

export default landingPageStyle;
